import { jsPDF as JsPDF } from 'jspdf'
import html2canvas from 'html2canvas'

const IMG_WIDTH = 210
const MARGIN = 5

export default function printViewByRef (ref, docName) {
  const DATE_FORMATTED = new Intl.DateTimeFormat('pt-BR').format(new Date())

  html2canvas(ref, {
    backgroundColor: '#ffffff'
  }).then(function (canvas) {
    const IMG_DATA = canvas.toDataURL('image/png')
    const IMG_HEIGHT = (canvas.height * IMG_WIDTH) / canvas.width

    const doc = new JsPDF('p', 'mm', 'A4')
    doc.setFillColor(255, 255, 255)

    doc.rect(
      MARGIN,
      MARGIN,
      IMG_WIDTH - MARGIN * 2,
      IMG_HEIGHT - MARGIN * 2,
      'F'
    )

    doc.addImage(
      IMG_DATA,
      'PNG',
      MARGIN,
      MARGIN,
      IMG_WIDTH - MARGIN * 2,
      IMG_HEIGHT - MARGIN * 2,
      '',
      'FAST'
    )

    doc.save(`dashboard-${docName}-${DATE_FORMATTED}.pdf`)
  })
}
